import styled from "styled-components";
import { contentStyles } from "../Global/FlexipageStyles";

export const CopyRowWrapper = styled.section`
    ${contentStyles}
`